/**
 * 已发件
*/
export default {
  namespace: 'testSentModels',
  state: {},
  effects: {},
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}